const FC_SLIDES_PER_VIEW = 1.2;

function initFeaturedCollectionSliders() {
  document.querySelectorAll('slider-component .slider--1-2-slides').forEach((slider) => {
    const component = slider.closest('slider-component');
    if (!component || component.dataset.fcSlidesInit === 'true') return;

    component.dataset.fcSlidesInit = 'true';

    component.initPages = function () {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = FC_SLIDES_PER_VIEW;
      this.totalPages = Math.max(1, Math.ceil(this.sliderItemsToShow.length - FC_SLIDES_PER_VIEW + 1));

      this.update();
    };

    component.initPages();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFeaturedCollectionSliders);
} else {
  initFeaturedCollectionSliders();
}

document.addEventListener('shopify:section:load', initFeaturedCollectionSliders);
